import { DownOutlined, UpOutlined } from '@ant-design/icons';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import React from 'react';
import styles from './shop_panel.less';

interface ShopPanelProps {
  isMobile: boolean;
  heading: string;
  className?: string;
}

export const ShopPanel: React.FC<ShopPanelProps> = (props) => {
  const { isMobile, heading, className } = props;
  const [open, setOpen] = React.useState(!isMobile);

  const height = open || !isMobile ? 'auto' : 0;

  return (
    <div className={classNames(styles.shopPanel, className)}>
      <h2 onClick={() => setOpen(!open)} className={styles.shopHeading}>
        {heading}
        {isMobile && open && <UpOutlined />}
        {isMobile && !open && <DownOutlined />}
      </h2>
      <AnimateHeight duration={500} height={height} easing="ease-out">
        <div className={styles.shopPanelContent}>{props.children}</div>
      </AnimateHeight>
    </div>
  );
};
